export const userTypes = {
  admin: 'admin',
  operator: 'operator',
  user: 'user',
  buildingAdmin: 'buildingAdmin',
  unassignedUser: 'unassignedUser',
  security: 'security',
  gestor: 'gestor',
  securityAdmin: 'securityAdmin',
}
export const DoorbellType = {
  N: '2N',
  GRM: 'GRM',
  FANVIL: 'FANVIL',
  INTELBRAS: 'INTELBRAS',
  AKUVOX: 'AKUVOX',
  GATE: 'GATE',
  SURIX_GATE: 'SURIX_GATE',
}
export const communicationTypes = {
  GENERAL: 'GENERAL',
  DELIVERY: 'DELIVERY',
  PACKAGE: 'PACKAGE',
  SOS: 'SOS',
  VISITS: 'VISITS',
  FARMACIA: 'FARMACIA',
  ENCOMIENDA: 'ENCOMIENDA',
  JARDINERO: 'JARDINERO',
  SALUD: 'SERVICIOS DE SALUD',
  ELECTRICISTA: 'ELECTRICISTA',
  SANITARIO: 'SANITARIO',
  CARPINTERO: 'CARPINTERO',
  FLETE: 'FLETE',
}

export const notificationTypes = {
  FARMACIA: 'FARMACIA',
  DELIVERY: 'DELIVERY',
  ENCOMIENDA: 'ENCOMIENDA',
  SERVICIOS: 'SERVICIOS',
}

export const EventType = {
  OPEN_DOOR: 'OPEN_DOOR',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILED: 'LOGIN_FAILED',
  SOS: 'SOS',
  RINGING: 'RINGING',
  OPEN_DOOR_INVITED: 'OPEN_DOOR_INVITED',
  ERROR: 'ERROR',
  MANUAL_ENTRY: 'MANUAL_ENTRY',
  MANUAL_EXIT: 'MANUAL_EXIT',
}

export const FieldTypes = {
  TextField: 'TextField',
  TextArea: 'TextArea',
  Autocomplete: 'Autocomplete',
  DoubleAutocomplete: 'DoubleAutocomplete',
  Switch: 'Switch',
  Select: 'Select',
  DatePicker: 'DatePicker',
  UploadImage: 'UploadImage',
  Checkbox: 'Checkbox',
  DoubleCheckbox: 'DoubleCheckbox',
  Schedules: 'Schedules',
  Companions: 'Companions',
  Chips: 'Chips',
  TakePhoto: 'TakePhoto',
  Custom: 'Custom',
}
